import React from 'react'
import { Modal, Button } from 'antd';
import NumberFormat from 'react-number-format';
function ViewModal({ closeModal, showModal, Title ,data,currencySymbol}) {
    return (
        <Modal className='modal-p-body'
            title={Title}
            closeIcon={<span className='icon close'></span>}
            onCancel={closeModal}
            open={showModal}
            footer={[
                <Button type="primary" key="back" onClick={closeModal} className='primary-btn'>
                    Close
                </Button>,
            ]}
        >
                <div className="bg-light-cardBg border border-light-cardBorder grid md:grid-cols-1 mt-4 rounded-lg">
                    { data?.length > 0 && data?.map((item) =>
                        <div className="border-b border-b-light-cardBorder flex items-center justify-between gap-4 px-2 py-3" key={item?.cardName || item?.coinName}>
                            <p className="mb-0 text-light-labelColor">{item?.cardName || item?.network}</p>
                            <h3 className="mb-0 text-light-valueColor font-medium dark:text-dark-valueColorate200"> {currencySymbol} {" "}
                            <NumberFormat
                                value={item?.balance}
                                displayType="text"
                                thousandSeparator={true}
                                decimalScale={Title==='Card Balances' ? 2 :4}
                            />
                            </h3>
                        </div>
                    )}
                </div>
        </Modal>
    )
}
export default ViewModal